'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _draftJs = require('draft-js');

var _lodash = require('lodash');

exports.default = function (_ref, _ref2) {
    var isEditing = _ref.isEditing;
    var getEditorState = _ref2.getEditorState,
        setEditorState = _ref2.setEditorState;
    return function () {
        if (!isEditing) return;

        // Get the selection state before a delay
        var selection = getEditorState().getSelection();

        // For some reason Draft has started changing focus back to the start of the editor when the checkboxes are
        // clicked, so this will wait until after the focus has been changed and then force it back to position it
        // was before the focus was changed.
        (0, _lodash.defer)(function () {
            var editorState = getEditorState();
            var newEditorState = _draftJs.EditorState.forceSelection(editorState, selection);
            setEditorState(newEditorState);
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/richUtils/returnFocusToEditor.js
// module id = 1742
// module chunks = 0